document.addEventListener('DOMContentLoaded', function () {

  function updateEngravingFields() {

    const backInput = document.querySelector(
      '[data-custom-option-input="custom_option_aUTHdH"], [data-custom-option-input="54b05b66-8e7b-49c3-a8ba-877cf5f2b683"]'
    );

    const variantSelect = document.querySelector(
      'select[name^="options"]'
    );

    if (!backInput || !variantSelect) return;

    const backContainer = backInput.closest(
      '.product__controls-group'
    );

    if (!backContainer) return;

    if (variantSelect.value === 'Dos caras') {

      backContainer.style.display = '';

    } else {

      backContainer.style.display = 'none';

      backInput.value = '';

    }

  }


  updateEngravingFields();


  document.addEventListener('change', function (event) {

    if (event.target.matches('select[name^="options"]')) {
      setTimeout(updateEngravingFields, 100);
    }

  });

});